import {
  RichTextEditor,
  RichTextEditorProps,
  ToolbarElement,
} from '@shopify/legacy-rich-text-editor';

import {CodeMirrorEditor, InsertImageModal} from './components';

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

type Props = Optional<
  RichTextEditorProps,
  'CodeMirrorEditorComponent' | 'InsertImageModalComponent'
>;

export default function LegacyRichTextEditor(props: Props) {
  return (
    <RichTextEditor
      CodeMirrorEditorComponent={CodeMirrorEditor}
      InsertImageModalComponent={InsertImageModal}
      {...props}
    />
  );
}

export {ToolbarElement};
export type {Props};
